import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service7 from "../../assets/images/service/07.jpg";

const MaleInfertility = () => {

const data = {
title:"Male Infertility Treatment",
subtitle:"Andrology & fertility specialist at BBMH Hospital",

heading:"Best Male Infertility Specialist",
description:"Male infertility is a common issue affecting couples trying to conceive. At BBMH Hospital Bhilwara, advanced diagnosis and treatment for male infertility ensures effective solutions and successful parenthood.",

image:Service7,

sections:[

{
title:"What is Male Infertility?",
content:"Male infertility refers to a man's inability to cause pregnancy in a fertile female partner. It usually occurs due to low sperm production, poor sperm quality or blockage in sperm delivery. Male infertility can also be caused by hormonal imbalance, lifestyle factors or medical conditions. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced diagnosis and treatment for male infertility and sexual health problems with complete privacy and care."
},

{
title:"Common Causes of Male Infertility",
content:"Male infertility can occur due to several reasons:",
list:[
"Low sperm count or poor sperm quality",
"Hormonal imbalance",
"Varicocele (swelling of veins in testicles)",
"Infections affecting sperm production",
"Genetic conditions",
"Smoking, alcohol or drug use",
"Obesity and unhealthy lifestyle",
"Stress and anxiety"
]
},

{
title:"Symptoms of Male Infertility",
content:"In many cases, infertility has no obvious symptoms, but some men may experience:",
list:[
"Difficulty in conceiving",
"Low sexual desire",
"Erectile dysfunction",
"Pain or swelling in testicles",
"Reduced facial or body hair",
"Abnormal semen analysis"
]
},

{
title:"Diagnosis of Male Infertility",
content:"Proper diagnosis helps in finding exact cause of infertility. Dr. Sachitanand Chaurasia may recommend:",
list:[
"Semen analysis test",
"Hormone testing",
"Ultrasound of testicles",
"Physical examination",
"Genetic testing if required",
"Advanced fertility tests"
]
},

{
title:"Treatment Options for Male Infertility",
content:"Treatment depends on underlying cause and may include:",
list:[
"Medications and hormone therapy",
"Treatment of infections",
"Varicocele surgery",
"Lifestyle and diet improvement",
"Assisted reproductive techniques",
"Counselling and stress management"
]
},

{
title:"Treatment for Sexual Problems",
content:"Male sexual problems such as erectile dysfunction or premature ejaculation can also affect fertility and confidence. Advanced treatment options include:",
list:[
"Medical therapy",
"Lifestyle modification",
"Hormone treatment",
"Counselling and therapy",
"Advanced urology treatment"
]
},

{
title:"Benefits of Early Treatment",
content:"Early diagnosis and treatment improves chances of successful parenthood:",
list:[
"Improved fertility chances",
"Better sexual health",
"Increased confidence",
"Healthy family life",
"Safe and effective treatment"
]
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Male Infertility Treatment?",
content:"Dr. Sachitanand Chaurasia is an experienced urologist and andrology specialist providing advanced male infertility treatment. At BBMH (Brijesh Banger Memorial Hospital), patients receive confidential consultation, modern diagnostic tests and personalized treatment plans. The focus is on accurate diagnosis, effective treatment and successful results for every patient."
}

],

faq:[
{q:"Is male infertility curable?",a:"Many cases are treatable."},
{q:"Best test?",a:"Semen analysis."},
{q:"Treatment time?",a:"Depends on cause."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default MaleInfertility;
